export const fetchBitcoinData = async (address: string) => {
  try {
    const res = await fetch(`https://blockstream.info/api/address/${address}`);
    if (!res.ok) throw new Error('Failed to fetch BTC data');
    const data = await res.json();
    
    // Calculate balance from chain stats
    const funded = data.chain_stats.funded_txo_sum;
    const spent = data.chain_stats.spent_txo_sum;
    const balanceSatoshis = funded - spent;
    const nativeBalance = balanceSatoshis / 1e8;

    let nativePriceUsd = 0;
    const bRes = await fetch('https://api.binance.com/api/v3/ticker/price?symbol=BTCUSDT');
    if (!bRes.ok) throw new Error('BTC price fetch failed');
    const bData = await bRes.json();
    nativePriceUsd = parseFloat(bData.price);

    return {
      nativeBalance,
      nativeUsdValue: nativeBalance * nativePriceUsd,
      nativePriceUsd,
      assets: [] // Standard BTC doesn't have tokens easily queried from mempool.space without Ordinals/Runes apis
    };
  } catch (error) {
    console.error('Error fetching BTC data:', error);
    throw error;
  }
};
